import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Login as Login23 } from 'projects/flow-gui-access/views/2.3/core'
import { Login as Login24 } from 'projects/flow-gui-access/views/2.4/core'

class Login extends Component {
  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'auth' && endpoint.version === '2.4').length !== 0) {
      return <Login24 {...this.props} />
    } else if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'auth' && endpoint.version === '2.3').length !== 0) {
      return <Login23 {...this.props} />
    } else return false
  }
}
//eslint-disable-next-line
Login = connect(state => state)(Login)
export default Login



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/core/login.js